<template>

  <router-link :title="title" :class="hyperlink ? '' : 'btn btn-primary'" :to="routing">
    <span v-if="hyperlink">{{title}}</span>
    <i v-else :class="icon"></i>
  </router-link>
</template>

<script>
export default {
  components: {},
  props: {
    title: String,
    routing: Object,
    hyperlink: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'ti-eye'
    },
  },
}
</script>




